"use client";

import React, { useState, useRef, useEffect } from "react";

interface IShowMoreProps {
  children: React.ReactNode;
  lines?: number;
  more?: string;
  less?: string;
  className?: string;
}

const ShowMore: React.FC<IShowMoreProps> = ({
  children,
  lines = 4,
  more = "See more",
  less = "See less",
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      setShouldShowToggle(el.scrollHeight > el.clientHeight);
    }
  }, [children]);

  return (
    <div className={`${className}`}>
      <div
        ref={contentRef}
        className={`transition-all overflow-hidden ${
          isExpanded ? "max-h-full" : `line-clamp-${lines}`
        }`}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: isExpanded ? "unset" : lines,
          WebkitBoxOrient: "vertical",
        }}
      >
        {children}
      </div>
      {shouldShowToggle && (
        <button
          className="text-coral-pink-400 text-sm mt-2 font-medium cursor-pointer"
          onClick={() => setIsExpanded((prev) => !prev)}
          type="button"
        >
          {isExpanded ? less : more}
        </button>
      )}
    </div>
  );
};

export default ShowMore;
